import { render } from "./attribute.vue?vue&type=template&id=16685679&scoped=true"
import script from "./attribute.vue?vue&type=script&lang=js"
export * from "./attribute.vue?vue&type=script&lang=js"

import "./attribute.vue?vue&type=style&index=0&id=16685679&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16685679"

export default script